/* Rokovi za preuzimanje podataka:
   kartica vozača najkasnije na 28 dana, tahograf vozila najkasnije na 90 dana.
   Zakonski osnov obaveze: čl. 15 st. 5 Zakona o radnom vremenu posade vozila ("u propisanim rokovima");
   kazna za pravno lice čl. 57 t. 24 (30.000) bez gubitka podataka, čl. 55 t. 40 (120.000) sa gubitkom podataka.
   Prikaz: "za očitavanje" = do roka najviše 15 dana (uključuje istekle i nikad očitane), upozorenje = najviše 7 dana. */

export const ROK_KARTICA = 28;
export const ROK_VOZILO = 90;
export const PRAG_PRIKAZA = 15;
export const PRAG_UPOZORENJA = 7;
export const PRAG_ISTEKA_KARTICE = 30; // kartica vozača ističe za najviše 30 dana

const DAY = 86400000;
const midnight = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x.getTime(); };
export const daysBetween = (from, to = new Date()) => Math.floor((midnight(to) - midnight(from)) / DAY);

/**
 * Stanje jednog očitavanja.
 * @param last      datum poslednjeg očitavanja (ili null)
 * @param rok       28 ili 90
 * @param approx    datum poslednje aktivnosti kao procena kad nema evidencije fajla (samo kartice)
 * @param noCard    vozač nema upisan broj kartice — nema ni roka
 * @returns { kind, label, daysSince, daysLeft, basis, needsAction, severity }
 *   kind: 'NO_CARD' | 'NEVER' | 'EXPIRED' | 'WARN' | 'SOON' | 'OK'
 */
export function stanje({ last, rok, approx = null, noCard = false }) {
    if (noCard) return { kind: 'NO_CARD', label: 'Nije upisan broj kartice', daysSince: null, daysLeft: null, basis: null, needsAction: false, severity: 'neutral' };
    const basisDate = last || approx;
    if (!basisDate) return { kind: 'NEVER', label: 'Nikad očitavan', daysSince: null, daysLeft: null, basis: null, needsAction: true, severity: 'danger' };
    const daysSince = daysBetween(basisDate);
    const daysLeft = rok - daysSince;
    const basis = last ? 'fajl' : 'aktivnost';
    if (daysLeft < 0) return { kind: 'EXPIRED', label: `Rok istekao (${-daysLeft} ${-daysLeft === 1 ? 'dan' : 'dana'})`, daysSince, daysLeft, basis, needsAction: true, severity: 'danger' };
    if (daysLeft <= PRAG_UPOZORENJA) return { kind: 'WARN', label: `Ističe za ${daysLeft} ${daysLeft === 1 ? 'dan' : 'dana'}`, daysSince, daysLeft, basis, needsAction: true, severity: 'warn' };
    if (daysLeft <= PRAG_PRIKAZA) return { kind: 'SOON', label: `Ističe za ${daysLeft} dana`, daysSince, daysLeft, basis, needsAction: true, severity: 'neutral' };
    return { kind: 'OK', label: `U redu (${daysLeft} dana do roka)`, daysSince, daysLeft, basis, needsAction: false, severity: 'ok' };
}

/** Važnost kartice vozača: null | { expired, daysLeft } kad ističe za najviše 30 dana ili je istekla. */
export function vaznostKartice(expiry) {
    if (!expiry) return null;
    const daysLeft = daysBetween(new Date(), expiry);
    if (daysLeft > PRAG_ISTEKA_KARTICE) return null;
    return { expired: daysLeft < 0, daysLeft };
}

/* Redosled po hitnosti: nikad / istekao (najstariji prvo), upozorenje, uskoro, u redu, bez kartice. */
const RANG = { NEVER: 0, EXPIRED: 1, WARN: 2, SOON: 3, OK: 4, NO_CARD: 5 };
export const poHitnosti = (a, b) => (RANG[a.st.kind] - RANG[b.st.kind])
    || ((b.st.daysSince ?? -1) - (a.st.daysSince ?? -1))
    || String(a.naziv).localeCompare(String(b.naziv), 'sr');
